import { TaskTypeFormElement_TranslationDTO } from './taskTypeFormElement_TranslationDTO';
import KPIDTO from '../kpi/kpiDTO';

export default class TaskTypeFormElementDTO {
  taskTypeId: number;

  fieldId: number;

  fieldKey?: string;

  fieldType: number;

  fieldMode?: number;

  kpiId?: number;

  kpiDefinitionRevisionId?: number;

  kpiDefinitionRevisionRowVersion?: string;

  sortOrder: number;

  listId?: number;

  folderId?: string;

  kpi?: KPIDTO;

  //server-owned, one-way like kpi.hasAutomatedEvidence: the client renders these but never
  //writes them back, so they are absent from mapToTaskTypeForm
  entityType?: number;

  entityId?: number;

  criterionKey?: string;

  retiredOn?: string;

  //execution-task forms only: the criterion is outside the audit's standards and unanswered
  notApplicable?: boolean;

  trans: TaskTypeFormElement_TranslationDTO[];

  constructor() {
    this.taskTypeId = 0;
    this.fieldId = 0;
    this.fieldType = 0;
    this.sortOrder = 0;
    this.entityType = undefined;
    this.entityId = undefined;
    this.criterionKey = undefined;
    this.retiredOn = undefined;
    this.notApplicable = undefined;
    this.trans = [];
  }
}
